import React from 'react';
import { useEffect, useRef } from 'react';
import { NotificationBanner } from '@wix/wix-base-ui';
import { translate } from '#packages/i18n';
import type { MenuItem } from '@wix/document-services-types';
import { AUTOMATION_IDS } from '../panels/MenuManagePanel/utils/automationIds';
import { biLogger } from '#packages/util';
import { pagesPanelUpdateMenuMessageAction } from '@wix/bi-logger-components-data/v2';
interface MenuDeprecationNotificationBannerProps {
  menuItems: MenuItem[];
  panelType: string;
  openHelpCenter: (article: string) => void;
  setIsContextMenuOpen: (isOpen: boolean) => void;
}
const translationKeys = {
  text: 'custom_menu_manage_menu_add_subsub_notification',
  learnHowlink: 'custom_menu_manage_menu_new_horizontal_help',
};
const HELP_ID = 'f624782a-3225-43f9-bb3a-33341d23fda3';

const MenuDeprecationNotificationBanner: React.FC<
  MenuDeprecationNotificationBannerProps
> = ({
  menuItems,
  panelType,
  openHelpCenter,
  setIsContextMenuOpen,
}: MenuDeprecationNotificationBannerProps) => {
  const linkLearnHowRef = useRef(null);
  const NumOfPages = menuItems.length;
  const numOfHiddenPages = menuItems.filter(
    (item) => item.isVisible === false,
  ).length;

  const handleClick = () => {
    biLogger.report(
      pagesPanelUpdateMenuMessageAction({
        action: 'click',
        num_of_pages: NumOfPages,
        num_of_hidden_pages: numOfHiddenPages,
        panelType,
      }),
    );

    openHelpCenter(HELP_ID);
    setIsContextMenuOpen(false);
  };

  const fireViewBiEvent = () => {
    biLogger.report(
      pagesPanelUpdateMenuMessageAction({
        action: 'view',
        num_of_pages: NumOfPages,
        num_of_hidden_pages: numOfHiddenPages,
        panelType,
      }),
    );
  };

  useEffect(() => {
    fireViewBiEvent();
    let timer: ReturnType<typeof setTimeout>;

    const handleMouseEnter = () => {
      timer = setTimeout(() => {
        biLogger.report(
          pagesPanelUpdateMenuMessageAction({
            action: 'hover',
            num_of_pages: NumOfPages,
            num_of_hidden_pages: numOfHiddenPages,
            panelType,
          }),
        );
      }, 2000);
    };

    const handleMouseLeave = () => {
      clearTimeout(timer);
    };

    const linkElement = linkLearnHowRef.current?.querySelector('button');

    if (linkElement) {
      linkElement.addEventListener('mouseenter', handleMouseEnter);
      linkElement.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (linkElement) {
        linkElement.removeEventListener('mouseenter', handleMouseEnter);
        linkElement.removeEventListener('mouseleave', handleMouseLeave);
      }
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={linkLearnHowRef}
      data-aid={AUTOMATION_IDS.FOOTER.ACTIONS.NOTIFICATION_BANNER}
    >
      <NotificationBanner
        key={'menuDepracationNotificationBanner'}
        skin={'warning'}
        alignment={'start'}
        text={translate(translationKeys.text)}
        shouldTranslate={false}
        link={{
          label: translate(translationKeys.learnHowlink),
          onClick: () => handleClick(),
        }}
        multiline={true}
      />
    </div>
  );
};

export default MenuDeprecationNotificationBanner;
